module.exports = __webpack_public_path__ + "static/media/statementIconHover.91d10cc1.svg";